import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setEmail } from './../../Action/action' 

export class Employee extends Component {
    constructor() {
        super()
    }

    setEmail(email) {
        setEmail(email)
    }

    render() {
        return (
            <div className="card w-100 mx-auto my-3 bg-color-white shadow border-0">
                <div className="card-body row">
                    <div className="col-md-2 my-auto">
                        <img className="w-100 rounded" src={this.props.employee.image && this.props.employee.image}></img>
                    </div>

                    <div className="col">
                        <h5 className="card-title dm-sans">{this.props.employee.name}</h5>
                        <h6 className="card-subtitle mb-2 text-muted dm-sans">{this.props.employee.title}</h6>
                        <p className="card-text body-font enable-line">
                            {this.props.employee.bio}
                        </p>
                    </div>
                </div>
            </div>

        )
    }
}

Employee.propTypes = {
    employee: PropTypes.shape({
        name: PropTypes.string,
        title: PropTypes.string,
        bio: PropTypes.string,
        email: PropTypes.string
    })
}

const mapStateToProps = (state) => ({
    state
})

export default connect(mapStateToProps, { setEmail })(Employee)
